import { Map } from 'immutable';
import { isEmpty, isUndefined, forEach, map } from 'lodash';

import * as Constants from 'commons-vehicle/constants/apiDataConversionConstants.js';
import * as UtilitiesService from 'commons-vehicle/ModelYear/services/DataUtilitiesService/DataUtilitiesService.js';

const { DATA_TYPES } = Constants.VIEW_2_1;
const FEATURES_CONSTANTS = Constants.VIEW_2_1.VEHICLE.FEATURES;
const FEATURE_CONSTANTS = Constants.VIEW_2_1.VEHICLE.FEATURES.FEATURE;
const MODEL_YEAR_FEATURES_CONSTANTS = Constants.VIEW_2_1.VEHICLE.MODEL_YEAR.FEATURES;
const DEFAULT_KEY_ORDER = 9999999;
const DEFINED_RANK = 10000000;
const UNDEFINED_RANK = 30000000;
const FEATURE_TYPE_ID_START = 100;
const FEATURE_TYPE_IGNORE = 5;
const { DEFAULT_ICON } = Constants.VIEW_2_1;

export function getFeatureIcons(features, modelTrimFeatures) {
    const featureIcons = {};
    let featureCode = '';
    let featureDesc = '';
    let featureKeyOrder = DEFAULT_KEY_ORDER;

    forEach(features, (feature) => {
        const newFeature = feature;
        featureCode = newFeature.code;
        featureDesc = newFeature.description;
        featureKeyOrder = newFeature.keyOrder === 0 ? DEFAULT_KEY_ORDER : newFeature.keyOrder;

        if (newFeature.dataTypeID === DATA_TYPES.FEATURE && !isEmpty(newFeature.iconTypes)) {
            forEach(newFeature.iconTypes, (iconType, iconKey) => {
                if (isEmpty(featureIcons[iconKey]) || iconType.value > featureIcons[iconKey].value) {
                    featureIcons[iconKey] = iconType;
                    featureIcons[iconKey].featureCode = featureCode;
                    featureIcons[iconKey].featureCodes = [];
                    featureIcons[iconKey].featureCodes.push(featureCode);
                }
            });
        } else if (
            newFeature.dataTypeID === DATA_TYPES.FEATURE &&
            (newFeature.typeID > FEATURE_TYPE_ID_START || newFeature.typeID < FEATURE_TYPE_IGNORE)
        ) {
            newFeature.iconTypes[DEFAULT_ICON] = {
                iconCode: DEFAULT_ICON,
                value: 0,
                rank: featureKeyOrder,
                keyOrder: featureKeyOrder,
                description: featureDesc,
                featureCode,
            };

            if (isUndefined(featureIcons[DEFAULT_ICON])) {
                featureIcons[DEFAULT_ICON] = newFeature.iconTypes[DEFAULT_ICON];
                featureIcons[DEFAULT_ICON].featureCodes = [];
                featureIcons[DEFAULT_ICON].featureCodes.push(featureCode);
            } else {
                featureIcons[DEFAULT_ICON].featureCodes.push(featureCode);
            }
        }
    });

    forEach(modelTrimFeatures, (feature) => {
        if (!isEmpty(feature.iconTypes)) {
            forEach(feature.iconTypes, (iconType, key) => {
                if (isEmpty(featureIcons[key])) {
                    featureIcons[key] = iconType;
                    featureIcons[key].featureCode = feature.code;
                }
            });
        }
    });

    return featureIcons;
}

export function getIconFromFeatureCode(features, modelTrimFeatures, iconType, iconTypeKey, featureCode) {
    const iconObject = {
        code: featureCode,
        description: iconType.description,
        typeDescription: iconType.description,
        value: iconType.value,
    };

    let featureRank = DEFINED_RANK;
    let modelFeatureRank = DEFINED_RANK;
    let featureIsModelTrim = true;

    if (!isUndefined(features[featureCode])) {
        featureRank += features[featureCode].rank;
        modelFeatureRank += features[featureCode].rank;
        featureIsModelTrim = false;
        iconObject.description = features[featureCode].description;
        iconObject.typeDescription =
            iconTypeKey === DEFAULT_ICON ? features[featureCode].description : iconType.description;
    } else if (!isUndefined(modelTrimFeatures[featureCode])) {
        featureRank += DEFINED_RANK + modelTrimFeatures[featureCode].rank;
        modelFeatureRank += modelTrimFeatures[featureCode].rank;
        iconObject.description = modelTrimFeatures[featureCode].description;
        iconObject.typeDescription =
            iconTypeKey === DEFAULT_ICON ? modelTrimFeatures[featureCode].description : iconType.description;
    } else {
        featureRank = UNDEFINED_RANK;
        modelFeatureRank = UNDEFINED_RANK;
    }

    return {
        rank: featureRank,
        modelTrimRank: modelFeatureRank,
        code: iconTypeKey,
        isFromModelTrim: featureIsModelTrim,
        iconObject: Map(iconObject),
    };
}

function getModelFeatureOption(modelFeatureOptionData) {
    const modelFeatureOption = {};

    if (isEmpty(modelFeatureOptionData)) {
        return modelFeatureOption;
    }

    modelFeatureOption.code = modelFeatureOptionData[FEATURE_CONSTANTS.CODE];
    modelFeatureOption.type = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE];
    modelFeatureOption.keyOrder = modelFeatureOptionData[FEATURE_CONSTANTS.KEY_ORDER];
    modelFeatureOption.dataTypeID = modelFeatureOptionData[FEATURE_CONSTANTS.DATA_TYPE_ID];
    modelFeatureOption.typeID = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE_ID];
    modelFeatureOption.description = modelFeatureOptionData[FEATURE_CONSTANTS.DESCRIPTION];
    modelFeatureOption.isStandard = modelFeatureOptionData[FEATURE_CONSTANTS.IS_STANDARD];
    modelFeatureOption.typeIDs = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE_IDS];
    modelFeatureOption.colourFeatures = modelFeatureOptionData[FEATURE_CONSTANTS.COLOUR_FEATURES];

    modelFeatureOption.iconTypes = {};
    const icons = modelFeatureOptionData[FEATURE_CONSTANTS.TYPE_ICONS];
    if (!isEmpty(icons)) {
        forEach(icons, (icon) => {
            if (isEmpty(modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]])) {
                modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]] = {
                    rank: icon[FEATURE_CONSTANTS.ICON.KEY_ORDER],
                    keyOrder: icon[FEATURE_CONSTANTS.ICON.KEY_ORDER],
                    value: icon[FEATURE_CONSTANTS.ICON.VALUE],
                    description: icon[FEATURE_CONSTANTS.ICON.DESCRIPTION],
                    featureCode: modelFeatureOption.code,
                    featureCodes: [],
                };
                modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].featureCodes.push(
                    modelFeatureOption.code
                );
                if (
                    (modelFeatureOption.keyOrder === 0 &&
                        modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].keyOrder > 0) ||
                    modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].keyOrder <
                        modelFeatureOption.keyOrder
                ) {
                    modelFeatureOption.keyOrder =
                        modelFeatureOption.iconTypes[icon[FEATURE_CONSTANTS.ICON.CODE]].keyOrder;
                }
            }
        });
    } else if (
        modelFeatureOption.dataTypeID === DATA_TYPES.FEATURE &&
        (modelFeatureOption.typeID > FEATURE_TYPE_ID_START || modelFeatureOption.typeID === 0)
    ) {
        modelFeatureOption.iconTypes[modelFeatureOption.code] = {
            iconCode: DEFAULT_ICON,
            value: 0,
            rank: modelFeatureOption.keyOrder,
            keyOrder: modelFeatureOption.keyOrder,
            description: modelFeatureOption.description,
            featureCode: modelFeatureOption.code,
        };
    }

    return modelFeatureOption;
}

function splitModelFeaturesAndOptions(modelFeaturesAndOptionsData) {
    const modelFeaturesAndOptions = {
        trimsBitField: 0,
        trimsBitFields: 0,
        features: {},
        options: {},
    };

    if (isEmpty(modelFeaturesAndOptionsData)) {
        return modelFeaturesAndOptions;
    }

    const { trimsBitField, trimsBitFields } = UtilitiesService.getModelTrimsBitField(
        modelFeaturesAndOptionsData[FEATURES_CONSTANTS.BIT_FIELD]
    );

    modelFeaturesAndOptions.trimsBitField = trimsBitField;
    modelFeaturesAndOptions.trimsBitFields = trimsBitFields;
    forEach(modelFeaturesAndOptionsData[FEATURES_CONSTANTS.LIST], (modelFeatureOption) => {
        const featureOption = getModelFeatureOption(modelFeatureOption);
        if (featureOption.isStandard) {
            modelFeaturesAndOptions.features[featureOption.code] = featureOption;
        } else {
            modelFeaturesAndOptions.options[featureOption.code] = featureOption;
        }
    });

    return modelFeaturesAndOptions;
}

export function getModelYearFeaturesAndOptions(modelYearFeaturesAndOptionsData) {
    const featuresAndOptions = map(
        modelYearFeaturesAndOptionsData[MODEL_YEAR_FEATURES_CONSTANTS],
        (modelFeaturesAndOptions) => {
            return splitModelFeaturesAndOptions(modelFeaturesAndOptions);
        }
    );

    return featuresAndOptions;
}

export default {
    getFeatureIcons,
    getIconFromFeatureCode,
    getModelFeatureOption,
    splitModelFeaturesAndOptions,
    getModelYearFeaturesAndOptions,
};
